export function makeCitationId(index: number) {
  return `citation-${index}`;
}

export function makeCitationDefinitionId(index: number) {
  return `citation-definition-${index}`;
}
